import Splide from '@splidejs/splide';

function splideFullscreen() {

    // console.log('splideFullscreen');

    const splideBanner = document.querySelectorAll('.splide--fullscreen');

    splideBanner.forEach((item) => {

        const splide = new Splide(item, {
            type: 'fade',
            pagination: false,
            arrows: false,
            perPage: 1,
            rewind: true,
            autoplay: true,
            interval: 5000
        });

        splide.mount();

    });

}

export default splideFullscreen;